import React from 'react';
import styled from 'styled-components';
import Wrapper from 'gatsby-theme-vehicles/src/components/preview/components/wrapper';
import PreviewImage from 'gatsby-theme-vehicles/src/components/preview/components/image';
import PreviewExpected from 'gatsby-theme-vehicles/src/components/preview/components/expected';
import PreviewTitle from 'gatsby-theme-vehicles/src/components/preview/components/title';
import PreviewSubtitle from 'gatsby-theme-vehicles/src/components/preview/components/subtitle';
import PreviewPrice from 'gatsby-theme-vehicles/src/components/preview/components/price';
import PreviewSpecs from 'gatsby-theme-vehicles/src/components/preview/components/specs';
import PreviewCompany from 'gatsby-theme-vehicles/src/components/preview/components/company';
import { usePreview } from 'gatsby-theme-vehicles/src/components/preview/provider';
import getPricePropsByField from 'gatsby-theme-vehicles/src/helpers/get-price-props-by-field';
import ContentWrapper from '../../../components/row-preview-content-wrapper';

const RowPreview = ({ className }) => {
  const { vdp } = usePreview();
  const isExpected = vdp.vdpType === 'expected';

  return (
    <Wrapper $rowLayout className={className}>
      <div>
        <PreviewImage $rowLayout withLink />
        {isExpected && (
          <ContentWrapper $dark>
            <PreviewExpected />
          </ContentWrapper>
        )}
      </div>
      <div>
        <PreviewTitle fields={['make', 'model']} withLink />
        <PreviewSubtitle field="type" withLink />
        <ContentWrapper>
          <div>
            <PreviewSpecs
              $rowLayout
              iconVariant
            />
          </div>
          <PricesWrapper>
            {vdp.prices.map(({
              field,
              variant,
              ...props
            }, index) => (
              <PreviewPrice
                key={field}
                $variant={variant}
                $first={index === 0}
                withLink
                {...props}
                {...getPricePropsByField(field, variant)}
              />
            ))}
          </PricesWrapper>
        </ContentWrapper>
        <PreviewCompany />
      </div>
    </Wrapper>
  );
};

export const PricesWrapper = styled.div``;

export default styled(RowPreview)`
  margin-bottom: 2rem;
  border-bottom: 1px solid ${({ theme }) => theme.grayLightColor};
  border-radius: 0;
`;
